import { createAction, props } from '@ngrx/store';
import { AgentBlankFormModel } from '@shared/data-access/models';

export const setItemDetail = createAction('[Agent Blank Form] SET ITEM DETAIL', props<{ item: AgentBlankFormModel | null }>());

export const loadItemDetail = createAction('[Agent Blank Form] LOAD ITEM DETAIL', props<{ id: number }>());


